const $ = jQuery.noConflict();

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-product-listing__header-options'),
	$domProductSelectSideNav: $('.js-product-listing__header-options--side-nav'),
	$domProductSelectSort: $('.js-product-listing__header-options-sort'),
	$domProductSelectImg: $('.js-product-listing__header-options--with-img'),
	$domSearchFilterSelect: $('.js-search-filter__body-top-options'),
	$domSearchResultsSelect: $('.js-quick-search-results__wrap-date-options'),
	$domSearchFilterSelectImg: $('.js-search-filter__body-top-options--with-img'),
	$domRegisterDropdown: $('.js-register__form-dropdown'),
	$stateDropdown: $('.js-register__state-dropdown'),
	$countryDropdown: $('.js-register__country-dropdown'),
	$domAccountBusinessType: $('.js-account__business-type'),
	$domAccountBusinessOther: $('.js-account__business-other'),

	/** @description Initialize */
	init: function() {
		this.singleProductSelect();
		this.singleProductSelectSideNav();
		this.singleProductSort();
		this.singleProductSelectWIthImg();
		this.setOptionImgOnClick();
		this.setOptionImgOnLoad();
		this.singleSearchFilterSelect();
		this.singleSearchResultsSelect();
		this.singleSearchFilterSelectWithImg();
		this.searchFilterSetOptionImgOnClick();
		this.searchFilterSetOptionImgOnLoad();
		this.registerDropdown();
		this.accountDropdown();

		this.stateDropdown(Select2.$stateDropdown);
		this.stateDropdown($('.js-register__state-dropdown-shipping'));

		this.countryDropdown(Select2.$countryDropdown, 'js-register__state-dropdown');
		this.countryDropdown($('.js-register__country-dropdown-shipping'), 'js-register__state-dropdown-shipping');
	},

	singleProductSelect: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
			placeholder: 'Brand'
		});
	},

	singleProductSelectSideNav: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$domProductSelectSideNav.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class select-side-nav-dropdown',
			placeholder: 'Products'
		});
	},

	singleProductSort: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$domProductSelectSort.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
			placeholder: 'Sort by Recommended'
		});
	},

	singleSearchFilterSelect: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$domSearchFilterSelect.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'search-filter-dropdown',
			containerCssClass: 'search-filter-option',
			placeholder: 'Last 30 days'
		});
	},

	singleSearchResultsSelect: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$domSearchResultsSelect.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'quick-search-results-dropdown',
			containerCssClass: 'quick-search-results-option'
		});
	},

	singleProductSelectWIthImg: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */

		Select2.$domProductSelectImg.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'product-listing-dropdown-img',
			containerCssClass: 'product-listing-option-img',
			templateResult: formatState,
			placeholder: 'Material'
		});

		if (!($('.select2-selection__rendered').attr('title'))) {
			$('.select2-selection__rendered').addClass('placeholder-img-d-none');
		}

		Select2.$domProductSelectImg.on('select2:select', function() {
			$('.select2-selection__rendered').removeClass('placeholder-img-d-none');
		});

		function formatState(state) {
			const img = $(state.element).attr('data-thumbnail');
			const imgPlaceholder = $(state.element).attr('data-thumbnail-placeholder');
			if (img) {
				const $state = $(
					`<span class="select2-img"><img sytle="display: inline-block;" src="${img}" />${state.text}</span>`
				);
				return $state;
			} else {
				const $state = $(
					`<span class="select2-img"><img sytle="display: inline-block;" src="${imgPlaceholder}" />${state.text}</span>`
				);
				return $state;
			}
		}
	},

	singleSearchFilterSelectWithImg: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */

		$(document).find('.js-search-filter__body-top-options--with-img').select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'search-filter-dropdown-img',
			containerCssClass: 'search-filter-option-img',
			templateResult: formatState2,
			placeholder: 'All categories'
		});

		if (!($('.select2-selection__rendered').attr('title'))) {
			$('.select2-selection__rendered').addClass('placeholder-img-d-none');
		}

		Select2.$domSearchFilterSelectImg.on('select2:select', function() {
			$('.select2-selection__rendered').removeClass('placeholder-img-d-none');
		});

		function formatState2(state) {
			const img = $(state.element).attr('data-thumbnail');
			if (img) {
				const $state = $(
					`<span class="select2-img"><img sytle="display: inline-block;" src="${img}" />${state.text}</span>`
				);
				return $state;
			} else {
				const $state = $(
					`<span class="select2-img"><img sytle="display: inline-block;" src="../../../images/no-image.png" />${state.text}</span>`
				);
				return $state;
			}
		}
	},

	setOptionImgOnClick: () => {
		$('.js-product-listing__header-options--with-img').on('change', function(e) {
			const _self = $(e.currentTarget);
			const image = _self.find('option:selected').data('thumbnail');
			setTimeout(() => {
				_self.next().find('.select2-selection__rendered').append(`<img src="${image}" />`);
			}, 10);
		});
	},

	searchFilterSetOptionImgOnClick: () => {
		$('.js-search-filter__body-top-options--with-img').on('change', function(e) {
			const _self = $(e.currentTarget);
			const image = _self.find('option:selected').data('thumbnail');
			setTimeout(() => {
				_self.next().find('.select2-selection__rendered').append(`<img src="${image}" />`);
			}, 10);
		});
	},

	setOptionImgOnLoad: () => {
		$('.js-product-listing__header-options--with-img').each(function(e, el) {
			const image = $(el).find('option:selected').data('thumbnail');
			setTimeout(() => {
				$('.js-product-listing__header-options--with-img').next().find('.select2-selection__rendered').append(`<img src="${image}" />`);
			}, 10);
		});
	},

	searchFilterSetOptionImgOnLoad: () => {
		$('.js-search-filter__body-top-options--with-img').each(function(e, el) {
			const image = $(el).find('option:selected').data('thumbnail');
			setTimeout(() => {
				$('.js-search-filter__body-top-options--with-img').next().find('.select2-selection__rendered').append(`<img src="${image}" />`);
			}, 10);
		});
	},

	registerDropdown: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$domRegisterDropdown.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'register-dropdown',
			containerCssClass: 'register-option',
			placeholder: 'Business type'
		});
	},

	filtersSelect: () => {
		$('.js-custom-select-vue').select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
			placeholder: 'Sort by Recommended'
		});
	},

	stateDropdown: ($stateInput) => {
		$stateInput.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'register-dropdown',
			containerCssClass: 'register-option',
			placeholder: 'Select a State *'
		});
	},

	countryDropdown: ($countryInput, $option) => {
		$countryInput.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'register-dropdown',
			containerCssClass: 'register-option',
			placeholder: 'Select a Country *'
		});
		$countryInput.on('select2:select', function() {
			const countryValue = this.value;
			const states = window.jsStatesList[countryValue];

			// Sets first option as empty, si ut can have a placeholder after selection of a Country
			$(`.${$option} option`).remove();
			$(`.${$option}`).append($('<option>', {
				value: '',
				text: ''
			}));

			$.each(states, function(i, item) {
				$(`.${$option}`).append($('<option>', {
					value: i,
					text: item
				}));
			});
		});
		// preselect "us"
		setTimeout(() => {
			$countryInput.val('US').trigger('select2:select').trigger('change');
		}, 200);
	},

	accountDropdown: () => {
		Select2.$domAccountBusinessType.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			placeholder: 'Select business type'
		});
		Select2.$domAccountBusinessType.on('select2:select', function() {
			Select2.$domAccountBusinessOther.toggle(this.value === 'Other');
		});
		Select2.$domAccountBusinessOther.toggle(Select2.$domAccountBusinessType.val() === 'Other');
	},
};

export default Select2;
